import { render } from "./TableProdutosEditar.vue?vue&type=template&id=03f83874&scoped=true"
import script from "./TableProdutosEditar.vue?vue&type=script&lang=js"
export * from "./TableProdutosEditar.vue?vue&type=script&lang=js"

import "./TableProdutosEditar.vue?vue&type=style&index=0&id=03f83874&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f83874"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QInput,QBtn,QTooltip,QToggle,QIcon,QPopupProxy,QDate,QPagination});qInstall(script, 'directives', {ClosePopup});
